module.exports = "/v2/pages/dashboard/dist/50dbb6e374888bca6bd0070a7dbca0d4.svg";